import React, {Component} from 'react'

// eslint-disable-next-line
import { BrowserRouter as Router, Route, NavLink } from 'react-router-dom'

import './Menu.css'

class Menu extends Component {

	render(){
		return (

			<nav className="nav-desktop">
				<ul className="main-menu">
					<li><NavLink activeClassName="main-menu-active" exact to="/">Home</NavLink></li>
					<li><NavLink activeClassName="main-menu-active" to="/about">About Us</NavLink></li>
					<li><NavLink activeClassName="main-menu-active" to="/services">Services</NavLink></li>
					<li><NavLink activeClassName="main-menu-active" to="/book">Book</NavLink></li>
					<li><NavLink activeClassName="main-menu-active" to="/careers">Careers</NavLink></li>
					<li><NavLink activeClassName="main-menu-active" to="/contacts">Contacts</NavLink></li>
				</ul>
			</nav>
		)
	}
}

class MenuMobile extends Component {

	constructor(props) {
		super(props)
		this.state = {
			menuVisible: false
		}
	}

	burgerToggle = ( toggleOption ) => {

		let state = this.state

		if ( toggleOption === 'none' ){
			state.menuVisible = false;
		} else {
			if ( state.menuVisible === true ) {
				state.menuVisible = false
			} else {
				state.menuVisible = true
			}
		}
		this.setState( state )
	}

	render(){
		return (
			<nav className="nav-mobile">
				<div className="nav-mobile-bg"></div>
				<div className="mobile-menu-icon" onClick={ this.burgerToggle }>&#9776;</div>
				<div className="mobile-logo">
					<NavLink activeClassName="main-menu-active" exact to="/">
						<div className="header-logo-mobile" onClick={ () => this.burgerToggle('none') }></div>
					</NavLink>
				</div>
				<div className={ this.state.menuVisible === true ? "nav-mobile-menu-bg nav-mobile-menu-bg-visible" : "nav-mobile-menu-bg" } onClick={ this.burgerToggle }></div>
				<div className={ this.state.menuVisible === true ? "nav-mobile-menu nav-mobile-menu-visible" : "nav-mobile-menu" }>
					<ul className="main-menu-mobile" onClick={ this.burgerToggle }>
						<NavLink activeClassName="main-menu-active" exact to="/"><li className="main-menu-li-shade">Home</li></NavLink>
						<NavLink activeClassName="main-menu-active" to="/about"><li>About Us</li></NavLink>
						<NavLink activeClassName="main-menu-active" to="/services"><li className="main-menu-li-shade">Services</li></NavLink>
						<NavLink activeClassName="main-menu-active" to="/book"><li>Book</li></NavLink>
						<NavLink activeClassName="main-menu-active" to="/careers"><li className="main-menu-li-shade">Careers</li></NavLink>
						<NavLink activeClassName="main-menu-active" to="/contacts"><li>Contacts</li></NavLink>
					</ul>
				</div>
			</nav>
		)
	}
}

export {
	Menu,
	MenuMobile
}


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js